import { render, staticRenderFns } from "./PropertiesTabs.vue?vue&type=template&id=b78e9f12&scoped=true"
import script from "./PropertiesTabs.vue?vue&type=script&lang=js"
export * from "./PropertiesTabs.vue?vue&type=script&lang=js"
import style0 from "./PropertiesTabs.vue?vue&type=style&index=0&id=b78e9f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e9f12",
  null
  
)

export default component.exports